<!--
  @Input  General input field in Pentelion App
  WARNING: Change to Input.svelte should be reflected in Output.svelte as well.
-->

<script>
  import {fieldLabels, fieldHints, protoSkills} from "../core.js";
  import Ability from "./Ability.svelte";

	let {field, value, type = 'text', renderer = null, separate = false, unlabeled = false, class: className = '', style: styleDefs = ''} = $props()
	let label = $derived(fieldLabels[field] ?? field)
  let hint  = $derived(fieldHints[field] ?? null)

</script>


<!-------------------------------- HTML -------------------------------------->

{#if separate && !unlabeled}
	<label for={field} class:number={type==='number'} {separate} title={hint}>
		{#if field in protoSkills}
			<Ability ability={protoSkills[field]} />
		{:else}
			{label}
		{/if}
	</label>
{/if}
<div class="outputBox {className}" data-help={field}>
	<div class="output" class:number={type==='number'} style={styleDefs}>
		{#if renderer}
			{@render renderer(value)}
		{:else if type === 'HTML'}
			{@html value}
		{:else}
			<span>{value}</span>
		{/if}
	</div>
	{#if !separate && !unlabeled && label}
    <label for={field} class:number={type==='number'} title={hint}>{label}</label>
	{/if}
</div>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	label
		display: block
		color: colors.$grey-85
		border: none

	label.number
		width: 4ch
		text-align: center
		color: #aaa

	label[separate]
		line-height: 175%

	.outputBox
		display: flex
		flex-direction: column

		& label
			font-size: 75%
			padding-left: 5px

	.output
		width: 100%
		min-height: 27px
		padding-top: 5px
		border: none
		border-bottom: 2px solid colors.$grey-50
		background-color: colors.$grey-15
		text-align: inherit
		background: unset
		color: white

		&.number
			width: 100%
			text-align: center
			justify-self: center
			/* max-width: 200px */

</style>

<!-- from: https://github.com/countnazgul/svelte-input/tree/master -->